
@switch (compactMode) {
  @case (false) {
    <ng-container *ngTemplateOutlet="BasketCard"></ng-container>
  }
  @case (true) {
    <ng-container *ngTemplateOutlet="BasketCardCompact"></ng-container>
  }
}

<ng-template #BasketCard>
    <div [class]="'card flex flex-column h-12rem basket mb-1 class' + bsk.Information.color + ' colorbox-' +
        bsk.Information.basketType"
    (click)="onSelectBasket($event, bsk)"
    >
    <div class="flex align-item-center text-gray-700 text-xl">
      <div class="mr-auto text-center">
        <h5 class="ml-0 pl-2" pTooltip="{{ bsk.Information.Name }}"
        tooltipPosition="top">{{ trunc(bsk.Information.Label) }}</h5>
      </div>
    </div>
    <div class="flex justify-content-between mt-1 flex-wrap">
      <div class="flex flex-row">
        <img
          class="img-hover mr-2 mt-3"
          src="{{ bsk.Information.url }}"
          (error)="updateUrl(bsk)"
          (click)="onSelectBasket($event, bsk)"
          width="75"
          />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #BasketCardCompact>
    <div  [class]="'card img-hover flex flex-column basket-compact mb-1 class' + bsk.Information.color + ' colorbox-' +
        bsk.Information.basketType"
      (click)="onSelectBasket($event, bsk)"
      >
      <div class="flex align-item-center text-gray-700 text-xl basket-header">
        <div class="mr-auto text-center">
          <h5 class="text-sm ml-0 pl-2 pb-0 mb-0" pTooltip="{{ bsk.Information.Name }}"
          tooltipPosition="top">{{ trunc(bsk.Information.Label) }}</h5>
        </div>
      </div>
      <div class="flex justify-content-between mt-1 flex-wrap basket-footer">
        <div class="flex flex-row align-item-end">
          <img
            class="img-hover mr-2"
            src="{{ bsk.Information.url }}"
            (error)="updateUrl(bsk)"
            (click)="onSelectBasket($event, bsk)"
            width="50"
            />
          </div>
        </div>
      </div>
    </ng-template>